"use strict";Object.defineProperty(exports, "__esModule", {value: true});// index.ts
var _bbox = require('@turf/bbox');
var _helpers = require('@turf/helpers');
function center(geojson, options = {}) {
  const ext = _bbox.bbox.call(void 0, geojson);
  const x = (ext[0] + ext[2]) / 2;
  const y = (ext[1] + ext[3]) / 2;
  return _helpers.point.call(void 0, [x, y], options.properties, options);
}
var turf_center_default = center;



exports.center = center; exports.default = turf_center_default;
//# sourceMappingURL=index.cjs.map